import { render } from "./TaskComment.vue?vue&type=template&id=5d8e4ecb&scoped=true"
import script from "./TaskComment.vue?vue&type=script&lang=js"
export * from "./TaskComment.vue?vue&type=script&lang=js"

import "./TaskComment.vue?vue&type=style&index=0&id=5d8e4ecb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d8e4ecb"]])

export default __exports__